import React from 'react';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Core components
import ListItem from 'components/core/ListItem';
import MenuButton from 'components/core/MenuButton';
// Models
import mCompany from 'models/company';
// Custom
import { companyDataShape } from 'constants/PropTypesShapes';
import { showPath } from 'companies/navigation';
import withPermissions from 'hocs/WithPermissions';
import { companyItemMenuItems } from 'utils/MenuItems';

const handleSelect = (checked, id, onSelect) => {
  onSelect(checked ? id : null);
};

const CompanyChildItem = ({
  company,
  withActions,
  withSelection,
  selectedId,
  hasPermission,
  onAdd,
  onDelete,
  onSelect,
  level,
  withChildItem,
}) => (
  <ListItem
    level={level}
    primaryText={company.name}
    initiallyOpen
    nestedItems={
      withChildItem
        ? _map(mCompany.sortElements(company.children), (child) => (
          <CompanyChildItem
            key={child.id}
            company={child}
            withActions={withActions}
            withSelection={withSelection}
            selectedId={selectedId}
            hasPermission={hasPermission}
            onAdd={onAdd}
            onDelete={onDelete}
            onSelect={onSelect}
            level={level + 1}
          />
        ))
        : []
    }
    selection={
      withSelection
        ? {
          selected: selectedId === company.id,
          onSelect: (checked) => handleSelect(checked, company.id, onSelect),
        }
        : null
    }
    rightItem={
      withActions ? (
        <MenuButton
          obj={company}
          items={companyItemMenuItems(
            { cb: onAdd },
            { path: showPath(company.id) },
            { cb: onDelete },
          )}
        />
      ) : null
    }
  />
);

CompanyChildItem.propTypes = {
  company: companyDataShape.isRequired,
  withActions: PropTypes.bool,
  withSelection: PropTypes.bool,
  selectedId: PropTypes.number,
  hasPermission: PropTypes.func.isRequired,
  onAdd: PropTypes.func,
  onDelete: PropTypes.func,
  onSelect: PropTypes.func,
  level: PropTypes.number.isRequired,
  withChildItem: PropTypes.bool,
};

CompanyChildItem.defaultProps = {
  withActions: false,
  withSelection: false,
  selectedId: null,
  onAdd: null,
  onDelete: null,
  onSelect: null,
  withChildItem: false,
};

module.exports = withPermissions(CompanyChildItem);



// WEBPACK FOOTER //
// ./routes/app/routes/companies/assets/main/CompanyChildItem.js